import React from 'react';
import { AggregateColumnDirective } from '@syncfusion/ej2-react-grids';
import {
    AggregateColumnsDirective, AggregateDirective, AggregatesDirective,
} from '@syncfusion/ej2-react-grids';

export const FooterSum = (props) => <span>{props.Sum}</span>;
export const FooterCount = (props) => <span>{props.Count}</span>;

const SUM = 'Sum';
const COUNT = 'Count';
const CurrencyFormat = '$#,##0.00';

export const generateAggregatedColumns = (customColumns) => {

    const fixedAggregatedColumns = [
        { field: 'Row', type: COUNT, footerTemplate: 'Totals:', key: '1' },
        { field: 'driverCustomID', type: COUNT, key: '2' },
        { field: 'totalCollectedFare', type: SUM, format: CurrencyFormat, key: '4' },
        { field: 'totalRides', type: SUM, key: '5' },
        { field: 'totalCardPayment', type: SUM, format: CurrencyFormat, key: '6' },
        { field: 'totalAppPayment', type: SUM, format: CurrencyFormat, key: '7' },
        { field: 'totalAdvancePayment', type: SUM, format: CurrencyFormat, key: '8' },
        { field: 'totalDigitalCredits', type: SUM, format: CurrencyFormat, key: '9' },
        { field: 'totalCashPayment', type: SUM, format: CurrencyFormat, key: '10' },
        { field: 'beamFee', type: SUM, format: CurrencyFormat, key: '11' },
        { field: 'userIncome', type: SUM, format: CurrencyFormat, key: '12' },
        { field: 'orgIncome', type: SUM, format: CurrencyFormat, key: '13' },
    ].map(col => (
        <AggregateColumnDirective
            key={col.key}
            field={col.field}
            type={col.type}
            footerTemplate={col.footerTemplate}
            format={col.format}
        />
    ));


    // const membershipAggregateColumn = (
    //     <AggregateColumnDirective
    //         key='membership_1_mainkey_aggregate'
    //         field='membership_1'
    //         type={SUM}
    //         // format=CurrencyFormat
    //     />
    // );

    // const ownerAggregateColumn = (
    //     <AggregateColumnDirective
    //         key='owner_0_computed_aggregate'
    //         field='owner_0_computed'
    //         type={SUM}
    //         // format=CurrencyFormat
    //     />
    // );

    let dynamicAggregatedColumns = [];
    for (let i = 0; i < customColumns.length; i++) {
        for (let j = 0; j < customColumns[i].gridColumns.length; j++) {
            let column = customColumns[i].gridColumns[j];
            if (column.type === 'number') { //|| column.field.endsWith("_computed")
                dynamicAggregatedColumns.push(
                    <AggregateColumnDirective
                        key={`${column.field}_aggregate`}
                        field={column.field}
                        type={SUM}
                        footerTemplate={(props) => (<span>{props.Sum}</span>)}
                        format={CurrencyFormat}
                    />
                );
            }
        }
    }

    const aggregatedColumns = [...fixedAggregatedColumns, ...dynamicAggregatedColumns];

    // console.dir(`generateAggregatedColumns >> aggregatedColumns.length: ${aggregatedColumns.length}, aggregatedColumns: ${JSON.stringify(aggregatedColumns)}`);

    const aggregatedSection = () => (
        <AggregatesDirective key={`Aggregates_Key1_${aggregatedColumns.length || 0}`}>
            <AggregateDirective key={`Aggregates_Key2_${aggregatedColumns.length || 0}`}>
                <AggregateColumnsDirective key={`Aggregates_Key3_${aggregatedColumns.length || 0}`}>
                    {aggregatedColumns}
                </AggregateColumnsDirective>
            </AggregateDirective>
        </AggregatesDirective>
    );

    return aggregatedSection();
};
